mutationType